import React, { useState } from 'react';
import API from './api'; // Use your API instance
import './styles.css';

const CreatePost = () => {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await API.post(
                'posts/', // Your post creation endpoint
                { title, content } // Data to send with the request
            );
            if (response.status === 201) {
                window.location.href = '/django-posts'; // Redirect after successful post creation
            }
        } catch (err) {
            setError('Failed to create post');
        }
    };

    return (
        <div className="create-post-container">
            <div className="create-post-card">
                <h1>Create a New Post</h1>
                <form onSubmit={handleSubmit} className="create-post-form">
                    <input
                        type="text"
                        placeholder="Post Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className="create-post-input"
                    />
                    <textarea
                        placeholder="Post Content"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        rows="6"
                        className="create-post-textarea"
                    />
                    {error && <p className="error-message">{error}</p>}
                    <button type="submit" className="create-post-button">Create Post</button>
                </form>
            </div>
        </div>
    );
};

export default CreatePost;
